import React from 'react';
import { Box, Container, Tabs, Tab } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import RelatorioLider from '../components/relatorios/RelatorioLider';
import RelatorioAdmin from '../components/relatorios/RelatorioAdmin';
import RelatorioUsuario from '../components/relatorios/RelatorioUsuario';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`relatorio-tabpanel-${index}`}
      aria-labelledby={`relatorio-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const RelatoriosPage: React.FC = () => {
  const { usuario } = useAuth();
  const [tabAtual, setTabAtual] = React.useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTabAtual(newValue);
  };

  const isAdmin = usuario?.tipo === 'admin';
  const isLider = usuario?.eh_lider;

  // Se não for admin nem líder, mostrar apenas relatório pessoal
  if (!isAdmin && !isLider) {
    return (
      <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
        <RelatorioUsuario />
      </Container>
    );
  }

  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={tabAtual} onChange={handleChangeTab} aria-label="Relatórios">
          {isAdmin && <Tab label="Relatório Administrativo" />}
          {isLider && <Tab label="Relatório do Departamento" />}
          <Tab label="Meu Relatório" />
        </Tabs>
      </Box>

      {isAdmin && (
        <TabPanel value={tabAtual} index={0}>
          <RelatorioAdmin />
        </TabPanel>
      )}

      {isLider && (
        <TabPanel value={tabAtual} index={isAdmin ? 1 : 0}>
          <RelatorioLider />
        </TabPanel>
      )}

      <TabPanel value={tabAtual} index={isAdmin && isLider ? 2 : isAdmin || isLider ? 1 : 0}>
        <RelatorioUsuario />
      </TabPanel>
    </Container>
  );
};

export default RelatoriosPage;
